{
  "replaceMessage": "Upuść plik, aby zastąpić"
}
